import ApplicationController from '../application_controller.js'
import { parseString, formatNumber } from '../../commons.js'
/*
 * Transfer to cfile
 */

export default class TransferToCfileController extends ApplicationController {

  static targets = ["hourlyRate", "duration", "amount", "selectedUser", "checkBox"]

  select_deselect(e) {
    e.target.closest("form").querySelectorAll(".record_selector").forEach(checkbox => {
      checkbox.checked = e.target.checked
    })
    this.enableSubmit()
  }

  userSelect(e) {
    if (e.target.selectedIndex > 0) {
      e.target.classList.remove("field_with_errors")
      this.hourlyRateTarget.value = e.target.options[e.target.selectedIndex].dataset.rate
    } else {
      if (this.checkBoxTarget.checked) {
        e.target.classList.add("field_with_errors")
      }
      this.hourlyRateTarget.value = ""
    }
    this.recomputeTaskAmount()
    this.enableSubmit()
  }

  clickCheck(e) {
    var checked = e.target.checked
    var userSelected = this.selectedUserTarget.selectedIndex > 0
    if (checked == false) {
      this.selectedUserTarget.classList.remove("field_with_errors")
    } else {
      if (!userSelected) {
        this.selectedUserTarget.classList.add("field_with_errors")
      }
    }
    this.enableSubmit()
  }

  enableSubmit() {
    var can = false

    var checked = this.element.closest("form").querySelectorAll(".record_selector:checked")
    if (checked.length > 0) {
      can = true
      checked.forEach(e => {
        can = can && e.closest(".tr").querySelector(".user_selector").selectedIndex > 0
      })
    }
    var sub = this.element.closest("form").querySelector("input[type=submit]")
    sub.disabled = !can
  }

  recomputeTaskAmount(e) {
    var duration = parseString(this.durationTarget.value)
    var rate = parseString(this.hourlyRateTarget.value)
    this.amountTarget.value = formatNumber(duration / 60 * rate)
  }

}